import { IUserState } from './user';
import { userService } from '../api/user.api';
import { Module, GetterTree, MutationTree, ActionTree, Commit, ActionContext } from 'vuex';
import { IVuexState } from '@/store/store';
import { IUser } from './../api/user.interfaces';

export interface IUserState {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  emailConfirmed: boolean;
  passwordHash: string;
  signUpDate: number;
  username: string;
  permissions: any;
  stripeCustomerId: string;
  users?: IUser[];
}

const state: IUserState = {
  id: -1,
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  emailConfirmed: false,
  passwordHash: '',
  signUpDate: 0,
  stripeCustomerId: '',
  permissions: {},
  users: undefined,
};

const getters: GetterTree<IUserState, IVuexState> = {
  firstName: (state: IUserState) => state.firstName,
  lastName: (state: IUserState) => state.lastName,
  username: (state: IUserState) => state.username,
  email: (state: IUserState) => state.email,
  signUpdate: (state: IUserState) => state.signUpDate,
  users: (state: IUserState) => state.users,
};

const mutations: MutationTree<IUserState> = {
  reset: (state: IUserState) => {
    state.firstName = '';
    state.username = '';
  },

  request: (state: IUserState, user: IUser) => {
    state.firstName = user.firstName;
    state.lastName = user.lastName;
    state.username = user.username;
    state.email = user.email;
    state.signUpDate = user.signUpDate;
  },

  all: (state: IUserState, users: IUser[]) => {
    state.users = users;
  },
};

const actions: ActionTree<IUserState, IVuexState> = {
  reset: ({ commit }: { commit: Commit }) => {
    commit('reset');
  },

  get({ commit }: { commit: Commit }) {
    return userService.getUser().then((response: IApi<IUser>) => {
      commit('request', response.result);
    });
  },

  all({ commit }: { commit: Commit }) {
    return userService.getUsers().then((response: IApi<IUser[]>) => {
      commit('all', response.result);
    });
  },

  delete(context: ActionContext<IUserState, IVuexState>, id: string) {
    return userService.delete(id).then((response: IApi<string>) => {
      // const index = findWithAttr(context.state.users, 'id', id);
      // context.commit('delete', index);
      context.dispatch('user/all');
    });
  },
};

const namespaced: boolean = true;

export const user: Module<IUserState, IVuexState> = { namespaced, state, getters, actions, mutations };
